import axios from "axios";


const baseURL = process.env.VUE_APP_API_BASE_URL ;

const apiClient = axios.create({
    baseURL: baseURL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
});


apiClient.interceptors.request.use(config => {

    const token = localStorage.getItem('auth_token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, error => {
    return Promise.reject(error);
});





export default apiClient;